import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import { MetaTags } from "react-meta-tags"
import SeasonAction from "store/season-resource/actions"

export default function DetailSeason() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      code: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("カテゴリ名 必須項目です。"),
      code: Yup.string()
        .required("シーズンコード 必須項目です。")
        .min(0)
        .max(2),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        dispatch(SeasonAction.postData(values, callbackPost))
      } else {
        dispatch(
          SeasonAction.putData({ ...values, id: params.id }, callbackPut)
        )
      }
    },
  })

  const callbackPost = () => {
    history.push("/master/rtw-season")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/master/rtw-season")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
    const status = store.rtwProduct.status.find(i => i.value == data.status)
    validation.setFieldValue("statusName", status.label)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(SeasonAction.getDetail({ id: params.id }, callbackGetDetail))
    }
  }, [params.id])

  return (
    <>
      <MetaTags>
        <title>個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="RTWシーズンマスター" breadcrumbList={[]} />

          <Card>
            <CardBody>
              {store.rtwProduct.detail.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "RTWシーズンマスター詳細"
                          : "新規RTWシーズンマスター追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <Button
                        color="primary"
                        type="submit"
                        className="button me-2"
                      >
                        保存
                      </Button>
                      <br />
                      <Button
                        color="warning"
                        type="button"
                        className="button"
                        onClick={() => history.push("/master/rtw-season")}
                      >
                        キャンセル
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col sm="8">
                      <FormGroup row>
                        <Label sm="2">カテゴリ名</Label>
                        <Col sm="6">
                          <Input
                            name="name"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">シーズンコード</Label>
                        <Col sm="6">
                          <Input
                            name="code"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.code || ""}
                            invalid={
                              validation.touched.code && validation.errors.code
                                ? true
                                : false
                            }
                          />
                          {validation.touched.code && validation.errors.code ? (
                            <FormFeedback type="invalid">
                              {validation.errors.code}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
